export const faqs = [
    {
      question: "How do I sign up for an account?",
      answer:
        'Visit our Landing Page, click on "Sign Up,", Select the Platform , which you would like to Sign Up and complete the registration process. Once you have signed up, you can start creating and sending newsletters.',
    },
    {
      question: "What features are available in the free trial?",
      answer:
        "The free trial includes access to core features like email campaigns, basic analytics, and limited personalization.",
    },
    {
      question: "How do I upgrade or downgrade my plan?",
      answer:
        'Go to the account settings, choose "Manage Subscription" and select your desired plan to upgrade or downgrade.',
    },
    {
      question: "Can I import my existing email lists?",
      answer:
        'Yes, you can import email lists in supported formats (e.g., CSV) through the "Import Contacts" section.',
    },
    {
      question: "Can AI-generated newsletters be customized manually before sending?",
      answer:
        "Yes, you can manually edit AI-generated newsletters to adjust the content, tone, or formatting before sending them to your audience.",
    },
  ];
  
  export const billingFaqs = [
    {
      question: "What payment methods do you accept?",
      answer: "We accept PayPal and Stripe for payments.",
    },
    {
      question: "Can I change my payment method after subscribing?",
      answer:
        "Yes, you can update your payment method anytime from your account settings. If you need assistance, our support team is happy to help.",
    },
    {
      question:
        "What happens if I exceed my plan's subscriber limit or email sending limit?",
      answer:
        "If you exceed the limits of your plan, our platform will temporarily suspend your service or charge overage fees based on the number of additional emails sent and subscribers added. The cost will also vary based on the AI Token Usage. You can upgrade your plan to avoid these charges.",
    },
    {
      question: "Do you offer refunds if I cancel mid-plan?",
      answer: "Refund policies vary by plan. Do check our refund policy for more details.",
    },
    {
      question: "Is there a discount for annual subscriptions?",
      answer: "Yes, annual plans come with a discount compared to monthly billing.",
    },
  ];
  
  export const supportFaqs = [
    {
      question: "How do I contact customer support?",
      answer:
        "You can reach our support team via email and raise your concerns or raise issues through the support portal",
    },
    {
      question: "What should I do if I encounter a technical issue?",
      answer: "Try clearing your cache and refreshing the page. If the issue persists, contact support.",
    },
    {
      question: "Is there a knowledge base available?",
      answer: "Yes, we provide a knowledge base with FAQs, guides, and troubleshooting steps.",
    },
    {
      question: "What should I do if I don’t receive a response from customer support?",
      answer:
        "If you don’t receive a response within the expected time, check your spam folder or resend your request. You can also reach out via live chat for quicker assistance. Rest assured, our team is dedicated to resolving your concerns as quickly as possible.",
    },
    {
      question: "How long does it take to resolve support tickets?",
      answer: "Resolution time varies, but most tickets are addressed within 24-48 hours.",
    },
  ];
  